(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    function restubeTrackClick(eventName, params) {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, params || {});
      }
    }

    document.addEventListener('click', function (event) {
      // Explicitly tagged elements (checkout, view cart) always win first.
      var explicit = event.target.closest('[data-track-event]');
      if (explicit) {
        restubeTrackClick(explicit.getAttribute('data-track-event'), {
          item_name: explicit.getAttribute('data-track-label') || undefined
        });
        return;
      }

      var checkoutButton = event.target.closest('button[name="checkout"]');
      if (checkoutButton) {
        restubeTrackClick('cart_checkout_click');
        return;
      }

      // Recommendation cards and the free gift card both render via the shared "horizontal-product"
      // snippet, whose CTA (add to cart, or quick-buy trigger for multi-variant products) always lives
      // inside a ".horizontal-product__cta" wrapper. We track clicks by delegation instead of editing
      // that shared snippet, so this keeps working even if its markup changes slightly.
      var cta = event.target.closest('.horizontal-product__cta button, .horizontal-product__cta a');
      if (!cta) {
        return;
      }

      var card = cta.closest('.horizontal-product');
      var titleEl = card ? card.querySelector('.horizontal-product__info a, .horizontal-product__info span') : null;
      var itemName = titleEl ? titleEl.textContent.trim() : undefined;

      if (cta.closest('.free-gift-product')) {
        restubeTrackClick('cart_free_gift_add_click', { item_name: itemName });
      } else if (cta.closest('.cart-drawer__recommendations')) {
        restubeTrackClick('cart_recommendation_add_click', { item_name: itemName });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
